module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA7klEQVRIx2NgqImEIN7mxBmn9vz79+/bwV1P/awf2WpQiBjgRkOQ87zWB+9f//3w7k19IaVGO3W7o5lOLecz/N4qMnWeAU99GNWdzxBmx/5iudCddbKO1HY+AxCICTCtquIFOn8KVZ3PAAehtoSd//PapXfddW8aiohBDMhAlJ9pZSUB5/8nGjBgghAb9ufLQM53wHA+aQgrADp/Bdj5k+caYjp/UBpNkwChVTQSk/jOnH+eW7YrPnMzMYjYLPPm7Tegah6ZHuIRURl947ZbigbTSDIXZDT+4okMxyKMdqK2YxFGU92xWIymlmPhCAB53qvKpwvL0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/za.png
// module id = 961
// module chunks = 0